module.exports = __webpack_public_path__ + "img/max-color.6c2b9530.svg";